import { render, staticRenderFns } from "./PostulatedProjectsList.vue?vue&type=template&id=2a79a9b1&scoped=true"
import script from "./PostulatedProjectsList.vue?vue&type=script&lang=js"
export * from "./PostulatedProjectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a79a9b1",
  null
  
)

export default component.exports